import React from 'react'
import styles from './contacts.scss'
import KeyValue from '../KeyValue'

import i18n from 'lib/i18n'
const _ = i18n('officeContactZoom')

const phoneNumber = (number) => (<a href={`tel:${number}`}>{number}</a>)

export default class ContactZoom extends React.Component {
	static propTypes = {
		contact: React.PropTypes.object.isRequired,
		onShowContactModal: React.PropTypes.func.isRequired,
		onRemoveContact: React.PropTypes.func.isRequired,
		onCloseContact: React.PropTypes.func.isRequired,
	}
	render() {
		const {contact, onShowContactModal, onRemoveContact, onCloseContact} = this.props

        const fullAddress =
            <div>
                {contact.street}&nbsp;{contact.houseNum}&nbsp;{contact.houseNumExt} <br/>
                {contact.zip}&nbsp;{contact.city} <br/>
                {contact.country}
            </div>
		const email = <a href={`mailto:${contact.email}`}>{contact.email}</a>
		const name = contact.name || {}

		const columns = [
			[
				{label: _('firstName'), value: name.first},
				{label: _('lastName'), value: name.last},
				{label: _('address'), value: fullAddress},
				{label: _('phone'), value: phoneNumber(contact.phone)},
			],
			[
				{label: _('birthday'), value: contact.birthday},
				{label: _('email'), value: email},
				{label: _('language'), value: contact.language},
				{label: _('mobile'), value: phoneNumber(contact.mobile)},
			],
		]
		return (
			<div>
				<div className={styles.buttonsContainer}>
					<input
						onClick={() => onCloseContact()}
						type="button"
						className={`greyButton`}
						value={_('backToList')}
					/>
					<input
						onClick={() => onRemoveContact(contact)}
						type="button"
						className={`greyButton`}
						value={_('removeContact')}
					/>
					<input
						onClick={() => onShowContactModal(contact._id)}
						type="button"
						className={`greyButton`}
						value={_('editContact')}
					/>
				</div>
				<KeyValue array={columns}/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/office/contactZoom.jsx